import React, { useEffect, useState } from "react";
import { MdGroups, MdStar } from "react-icons/md";
import TeamManagementTable from "./components/TeamManagementTable";
import api from "../../../services/axios";
import SkeletonTable from "../../../components/skeleton/table";

const TeamManagement = () => {
  const [userData, setUserData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const columns = [
    { key: "id", header: "ID" },
    { key: "nmEmployee", header: "Nome" },
    { key: "email", header: "E-mail" },
    { key: "jobDescription", header: "Cargo" },
    { key: "nmProject", header: "Projeto" },
    { key: "nmCorporate", header: "Cliente" },
  ];

  useEffect(() => {
    setLoading(true);
    api
      .get("/EmployeeClientProject/list")
      .then((response) => {
        setUserData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoading(true);
      });
  }, []);

  return (
    <div className="mt-5 animate-fade-up">
      {/* Page header */}
      <div className="mb-6 flex items-center gap-4">
        <span
          className="dv-aura flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow"
          aria-hidden="true"
        >
          <MdGroups className="h-6 w-6" />
        </span>
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-dv-blue-500/10 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.18em] text-dv-blue-600 dark:text-dv-cyan-300">
            <MdStar className="h-3.5 w-3.5" aria-hidden="true" />
            Equipe
          </span>
          <h1 className="mt-1.5 text-2xl font-extrabold tracking-tight text-navy-700 dark:text-white">
            Gestão de equipe
          </h1>
        </div>
      </div>

      <div className="grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        {loading ? (
          <SkeletonTable active={loading} />
        ) : (
          <TeamManagementTable columns={columns} data={userData} />
        )}
      </div>
    </div>
  );
};

export default TeamManagement;
